import clsx from 'clsx';
import { ReactNode } from 'react';

import EditablePictureContainer from '~components/generic/editable-picture/EditablePictureContainer';
import { Link } from '~components/generic/elements/Link/Link';
import { IEntityComponentProps } from '~interfaces/props';
import { convertToRawValue } from '~services/data-conversion';
import { getFieldValue, getRelatedEntityIds } from '~services/entity-helpers';
import { getModuleUrlIdFromData } from '~services/location-helpers';

const ModuleMoodboardImage = ({
  data,
  uploadFileAction,
  editing,
  className,
  onChange,
  proportions,
  editablePictureClassName,
  entityDef,
  isEditing,
  customMoodboard,
}: IEntityComponentProps) => {
  if (!data) {
    return null;
  }
  const content = data.attributes;
  const classes = clsx({
    ...className,
    relative: false,
    'c-moodboard-image': true,
    container: false,
  });

  const showBorder = Boolean(data.attributes.field_show_border);
  const borderRadius = parseInt(data.attributes.field_border_radius || '0', 10);
  const imagePosition = data.attributes.field_json_data || `{"x":50,"y":50}`;

  const imageId = getRelatedEntityIds(data, 'field_image')[0];
  const hasLink =
    getFieldValue<string>(data, 'attributes.field_link_internal') ||
    getFieldValue<string>(data, 'attributes.field_link_external.uri');
  const wrapperLink = (children: ReactNode) =>
    editing || !hasLink ? (
      <span className="c-moodboard-image__link">{children}</span>
    ) : (
      <Link
        className="c-moodboard-image__link"
        id={getFieldValue<string>(data, 'attributes.field_link_internal')}
        url={getFieldValue<string>(data, 'attributes.field_link_external.uri')}
      >
        {children}
      </Link>
    );

  const onChangePosition = (data: { x: number; y: number }) => {
    onChange('attributes.field_json_data', JSON.stringify(data));
  };

  return (
    <div className={classes} id={getModuleUrlIdFromData(data.id, data.type)}>
      {wrapperLink(
        <span>
          <div className="c-moodboard-image__background">
            <EditablePictureContainer
              showWhenEmpty={true}
              entityType={data.type}
              fieldName="relationships.field_image"
              editing={editing}
              onChangeImage={onChange}
              onUpload={uploadFileAction}
              entityId={imageId}
              proportions={proportions || '1:1'}
              className={editablePictureClassName}
              placeholder={isEditing && entityDef.fields['relationships.field_image'].options.placeholder}
              border={showBorder}
              borderRadius={borderRadius}
              customMoodboard={customMoodboard}
              onChangePosition={onChangePosition}
              imagePosition={imagePosition}
            >
              <div className="c-moodboard-image__overlay" style={{ zIndex: 1 }}>
                <div className="c-moodboard-image__heading">
                  {!content.field_hide_title && content.field_title && content.field_title.value && (
                    <h4>{convertToRawValue(content.field_title.value)}</h4>
                  )}
                </div>
                {hasLink && (
                  <Link
                    id={getFieldValue<string>(data, 'attributes.field_link_internal')}
                    url={getFieldValue<string>(data, 'attributes.field_link_external.uri')}
                    label={getFieldValue<string>(data, 'attributes.field_link_text')}
                    className="c-moodboard-image__button c-button--light"
                  />
                )}
              </div>
            </EditablePictureContainer>
          </div>
        </span>,
      )}
    </div>
  );
};

export default ModuleMoodboardImage;
